import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-600/20 bg-primary px-5 py-6 text-center text-sm text-slate-400 md:px-8">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 sm:flex-row">
        <p>&copy; {currentYear} Jeffrey Lau. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
